import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useServerRegenerateToken} from 'features/server/model/useServerMutations';
import Key from 'shared/ui/icons/General/Key';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import MainModal from 'shared/ui/Modal/MainModal';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import IServerOutput from 'features/server/model/Server/IServer';

import {PALETTE} from 'shared/config/model/palette';

import ServerAgentConnectionScreen from '../ServerAgentConnectionScreen/ServerAgentConnectionScreen';

import styles from './ServerRegenerateTokenModal.module.scss';

interface IServerRegenerateTokenModalProps {
    item: IServerOutput,
    open: boolean;
    handleClose: () => void;
}

const ServerRegenerateTokenModal: React.FC<IServerRegenerateTokenModalProps> = ({ item, open, handleClose }) => {
    const {regenerate, closeAndReset: handleCloseAndReset, newToken, isLoading} = useServerRegenerateToken({
        uuid: item.uuid,
        handleClose,
    });

    return (
        <MainModal
            header={newToken ? t`Новый токен агента` : t`Перевыпуск токена`}
            open={open}
            handleClose={handleCloseAndReset}
            size="md"
            dialogClassName={styles.background}
        >
            {
                newToken
                    ? (
                        <ServerAgentConnectionScreen
                            token={newToken}
                            serverUuid={item.uuid}
                            variant="setToken"
                            onDone={handleCloseAndReset}
                        />
                    )
                    : (
                        <>
                            <ModalBodyWrapper>
                                <div className={styles.wrapper}>
                                    <div className={styles.iconCircle}>
                                        <Key color={PALETTE.neutral}/>
                                    </div>
                                    <div className={styles.text}>
                                        <span className={styles.title}>
                                            <Trans
                                                id="modal.server.regenerateToken.title"
                                                message="Перевыпустить токен агента для сервера"
                                            />
                                        </span>
                                        <span className={styles.name}>«{item.name}»?</span>
                                        <span className={styles.hint}>
                                            <Trans
                                                id="modal.server.regenerateToken.hint"
                                                // eslint-disable-next-line max-len
                                                message="Старый токен перестанет работать немедленно. Агента на сервере нужно будет переконфигурировать новым токеном."
                                            />
                                        </span>
                                    </div>
                                </div>
                            </ModalBodyWrapper>
                            <ModalBlockButton
                                primaryButtonText={t`Перевыпустить`}
                                primaryButtonType="submit"
                                primaryButtonOnClick={regenerate}
                                primaryButtonLoading={isLoading}
                                secondaryButtonOnClick={handleCloseAndReset}
                            />
                        </>
                    )
            }
        </MainModal>
    );
};

export default ServerRegenerateTokenModal;
